import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './langs/zh_CN/zh'
import en from './langs/en_US/en'
import ja from './langs/ja-JP/ja'
import r3zh from './langs/zh_CN/r3zh'
import r3en from './langs/en_US/r3en'
// import ja from './langs/ja'
// import ChineseDictionary from '@/langs/ChineseDictionary'

Vue.use(VueI18n)

window.ChineseDictionary = require('./langs/ChineseDictionary').default

const messages = {
  en: Object.assign(en, r3en),
  zh: Object.assign(zh, r3zh),
  ja: Object.assign(ja),
}

if (!localStorage.getItem('locale')) {
  localStorage.setItem('locale', 'zh');
}

window.$i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'zh',
  messages
})

export default $i18n
